import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Renderer2, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ObsService } from '../../core/http/obs.service';
import { SampleService } from '../../core/http/sample.service';
import {MatSnackBar} from '@angular/material/snack-bar';



@Component({
  selector: 'app-obs-finalize',
  templateUrl: './obs-finalize.component.html',
  styleUrls: ['./obs-finalize.component.scss']
})
export class ObsFinalizeComponent implements OnInit {
  @ViewChild('result', {static: false}) ref: ElementRef;


  patient;
  FetchPatient;
  Patient_type: any =[]
  gender: any =[]
  AmnioticFluid: any = []
  CervicalOs: any = []
  Chorionicity: any = []
  Amnionicity: any = []
  Grade: any = []
  PlacentaLocation: any = []
  PlacentaLocationAnatomic: any = []
  Presentation: any = []
  FetalAnomaly: any = []
  NoofFetus: any = []
  TechnicalConditions: any = []
  FetalHeartBeat: any = []
  image1: any = []
  image2: any = []
  templates
  htmlStr
  isSaveLoading: boolean= false
  message;

  constructor(private change: ChangeDetectorRef, public router: Router, private obs: ObsService, private sample: SampleService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {

      this.obs
        .getDropdownValues(1)
        .subscribe(
          (resSuccess) => {
            this.Patient_type = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(24)
        .subscribe(
          (resSuccess) => {
            this.TechnicalConditions = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(25)
        .subscribe(
          (resSuccess) => {
            this.FetalHeartBeat = resSuccess
          },
          (resErr) => {
          }
        );
        this.obs
        .getDropdownValues(29)
        .subscribe(
          (resSuccess) => {
            this.image1 = resSuccess
          },
          (resErr) => {
          }
        );
        this.obs
        .getDropdownValues(28)
        .subscribe(
          (resSuccess) => {
            this.image2 = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(23)
        .subscribe(
          (resSuccess) => {
            this.NoofFetus = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(22)
        .subscribe(
          (resSuccess) => {
            this.FetalAnomaly = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(21)
        .subscribe(
          (resSuccess) => {
            this.Presentation = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(20)
        .subscribe(
          (resSuccess) => {
            this.PlacentaLocationAnatomic = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(19)
        .subscribe(
          (resSuccess) => {
            this.PlacentaLocation = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(18)
        .subscribe(
          (resSuccess) => {
            this.Grade = resSuccess
          },
          (resErr) => {
          }
        );
        
        this.obs
        .getDropdownValues(17)
        .subscribe(
          (resSuccess) => {
            this.Amnionicity = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(16)
        .subscribe(
          (resSuccess) => {
            this.Chorionicity = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(15)
        .subscribe(
          (resSuccess) => {
            this.CervicalOs = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(14)
        .subscribe(
          (resSuccess) => {
            this.AmnioticFluid = resSuccess
          },
          (resErr) => {
          }
        );

        this.obs
        .getDropdownValues(13)
        .subscribe(
          (resSuccess) => {
            this.gender = resSuccess
          },
          (resErr) => {
          }
        );

    this.patient = this.obs._patient;
    this.obs
      .getPatient(this.patient.patient_id)
      .subscribe(
        (resSuccess) => {

          this.FetchPatient = resSuccess[0]
        },
        (resErr) => {
        }
      );

      this.sample
      .getdetails(this.patient.result_id)
      .subscribe(
        (resSuccess) => {
          this.templates = resSuccess
          this.htmlStr = this.templates.data
          this.change.detectChanges()
          this.ref.nativeElement.innerHTML = this.templates.data
          console.log(this.templates)
        },
        (resErr) => {
        }
      )
  }

  dateChange(e) {
    
  }

  onSubmit(e) {
    // e.preventDefault();
    this.isSaveLoading = true;
    let is_finalized = true;
      this.sample
        .postResultFinalize(
          this.patient.result_id,
          is_finalized,
        )
        .subscribe(
          (resSuccess) => {
  
            this.message = resSuccess
            this.isSaveLoading = false;
            console.log(resSuccess)
  
            if (this.message.success) {
              console.log(this)
              this._snackBar.open('Saved Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              }); 

            }
            else {
              console.log("error")
              this._snackBar.open('Result already Finalized', '', {
                duration: 2000,
                verticalPosition: 'top',
              }); 
            }
            
          },
          (resErr) => {
            this.isSaveLoading = false; 
            this._snackBar.open('Error: try again', '', {
              duration: 2000,
              verticalPosition: 'top',
            }); 
            console.log(resErr)
          }
        );
  }


}
